import { render } from "./NewPhysicianHH.vue?vue&type=template&id=690dbf82&ts=true"
import script from "./NewPhysicianHH.ts?vue&type=script&lang=ts&external"
export * from "./NewPhysicianHH.ts?vue&type=script&lang=ts&external"

import "./NewPhysicianHH.vue?vue&type=style&index=0&id=690dbf82&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__